<template>
    <div>
        <textarea :name="textareaName" id="" cols="30" rows="10" v-model="textareaValue" class="form-control"></textarea>
        <p>{{ t('number of SMS', { length: smsInfo.length, encoding: smsInfo.encoding, segments: smsInfo.segments }) }}</p>
    </div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { smsCount } from '@/utils/sms';

const { t } = useI18n();

interface Props {
    name: string;
    value: string;
}

const props = defineProps<Props>();

const textareaName = ref('');
const textareaValue = ref('');

const smsInfo = computed(() => smsCount(textareaValue.value));

onMounted(() => {
    textareaName.value = props.name;
    textareaValue.value = props.value;
});
</script>